import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, DynamicSvg, GradientView, Typography, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { Pressable, View } from 'react-native';
import { getOfferContextualStripWidgetStyles } from './OfferContextualStripWidgetStyles';
export var OfferContextualStripWidgetComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'OfferContextualStripWidget' : _props$testID,
    _props$multiText = props.multiText,
    multiText = _props$multiText === void 0 ? [] : _props$multiText,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'default' : _props$variant,
    iconName = props.iconName,
    style = props.style,
    _props$isFullWidth = props.isFullWidth,
    isFullWidth = _props$isFullWidth === void 0 ? true : _props$isFullWidth,
    onPressMetaData = props.onPressMetaData,
    _props$actionType = props.actionType,
    actionType = _props$actionType === void 0 ? 'none' : _props$actionType,
    actionTypeOnPress = props.actionTypeOnPress,
    actionTypeProps = props.actionTypeProps,
    onUserAction = props.onUserAction;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var OfferContextualStripWidgetWidgetStyles = getOfferContextualStripWidgetStyles(props, isSmallScreen);
  var IconTextComponent = _jsxs(View, Object.assign({
    style: OfferContextualStripWidgetWidgetStyles.iconTextContainer
  }, {
    children: [!!iconName && _jsx(DynamicSvg, {
      iconName: iconName,
      style: OfferContextualStripWidgetWidgetStyles.icon
    }), _jsx(View, Object.assign({
      style: OfferContextualStripWidgetWidgetStyles.textContainer
    }, {
      children: _jsx(Typography, {
        multiText: multiText,
        color: OfferContextualStripWidgetWidgetStyles.text.color
      })
    }))]
  }));
  var ButtonComponent = _jsx(Button, Object.assign({
    onPress: () => actionTypePressHandler(),
    buttonType: "tertiary",
    iconName: actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconName,
    iconPosition: "right",
    size: isSmallScreen ? 'sm' : 'md',
    title: actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.buttonText
  }, actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.buttonProps, actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.accessibilityProps));
  var ActionIconComponent = (actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconName) ? _jsx(Pressable, Object.assign({
    onPress: () => actionTypePressHandler()
  }, {
    children: _jsx(DynamicSvg, Object.assign({
      iconName: actionTypeProps === null || actionTypeProps === void 0 ? void 0 : actionTypeProps.iconName,
      fontSize: "24"
    }, getTestId(testID, 'icon')))
  })) : null;
  var actionTypePressHandler = () => {
    actionTypeOnPress && onUserAction(Object.assign({
      id
    }, actionTypeOnPress), props);
  };
  var GET_ACTION_COMPONENT = {
    none: _jsx(_Fragment, {}),
    icon: ActionIconComponent,
    button: ButtonComponent
  };
  var children = _jsxs(View, Object.assign({
    style: OfferContextualStripWidgetWidgetStyles.container
  }, {
    children: [IconTextComponent, _jsx(View, Object.assign({
      style: OfferContextualStripWidgetWidgetStyles.offerAppendCta
    }, {
      children: GET_ACTION_COMPONENT[actionType]
    }))]
  }));
  return _jsx(_Fragment, {
    children: (multiText === null || multiText === void 0 ? void 0 : multiText.length) > 0 && _jsx(Pressable, Object.assign({
      onPress: () => {
        onPressMetaData && onUserAction(Object.assign({
          id
        }, onPressMetaData), props);
      }
    }, {
      children: _jsxs(View, Object.assign({
        style: [style, isFullWidth && {
          width: '100%'
        }]
      }, {
        children: [variant === 'default' && _jsx(GradientView, Object.assign({
          style: OfferContextualStripWidgetWidgetStyles.gradientContainer
        }, {
          children: children
        })), variant !== 'default' && children]
      }))
    }))
  });
};
OfferContextualStripWidgetComponent.genericRendererKey = 'AirOfferContextualStripWidget';